import { BooleanPropertyDTO } from 'business/models/Models';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import NavItem from 'components/sidebar/NavItem';
import { useSystemProperty } from 'CustomHooks/useSystemProperty';
import { PropertyConstants } from 'enums/PropertyConstants';
import React from 'react';
import {
  useGetSelectedTargetCharts,
  useIsWellDropOrXtalSearch,
  useSearchResult,
} from 'redux/hooks/searchnFilter';
import { ESnfRouteSegment, getSnfRoutePath } from '../constants';

const iconColor = '#fff';

interface Props {
  to: string;
}

const Sidebar = (props: Props) => {
  const { to } = props;
  const searchResults = useSearchResult();
  const isCanvasEnabled = useSystemProperty<BooleanPropertyDTO>(
    PropertyConstants.SeachFilterEnableCanvas,
    false,
  );
  const isWellDropOrXtalSearch = useIsWellDropOrXtalSearch();
  const isDisableCanvasRoutes =
    !isCanvasEnabled || !isWellDropOrXtalSearch || searchResults.rows.items.length == 0;
  const selectedTargetCharts = useGetSelectedTargetCharts();

  return (
    <div
      id="searchandfilter-index-sidebar-wrapper"
      className="sidebar border-sidebar h-100"
    >
      <NavItem
        to={getSnfRoutePath(to)}
        label="Info"
        key="index"
        isDisabled={false}
        icon={<RMSvgIcon id="searchandfilter-svg-info-icon" name="SearchandFilterInfo" />}
      />
      <NavItem
        to={getSnfRoutePath(to, ESnfRouteSegment.Result)}
        label="Result"
        key="result"
        icon={
          <RMSvgIcon id="searchandfilter-svg-result-icon" name="SearchandFilterResult" />
        }
      />
      {isCanvasEnabled && (
        <>
          <NavItem
            to={getSnfRoutePath(to, ESnfRouteSegment.Canvas)}
            label="Canvas"
            key="canvas"
            isDisabled={isDisableCanvasRoutes}
            icon={
              <RMSvgIcon
                id="searchandfilter-svg-canvas-icon"
                name="SearchandFilterCanvas"
              />
            }
          />
          <NavItem
            to={getSnfRoutePath(to, ESnfRouteSegment.Drop)}
            label="Drop"
            key="drop"
            isDisabled={isDisableCanvasRoutes}
            icon={<RMSvgIcon id="searchandfilter-svg-drop-icon" name="Drop" />}
          />
          <NavItem
            to={getSnfRoutePath(to, ESnfRouteSegment.Compare)}
            label="Compare"
            key="compare"
            isDisabled={isDisableCanvasRoutes}
            icon={
              <RMSvgIcon
                id="searchandfilter-svg-compare-icon"
                name="Compare"
                fill={iconColor}
              />
            }
          />
        </>
      )}
      <NavItem
        to={getSnfRoutePath(to, ESnfRouteSegment.Analytics)}
        label="Graph"
        key="analytics"
        isDisabled={!selectedTargetCharts?.length || searchResults.rows.items.length == 0}
        icon={
          <RMSvgIcon id="searchandfilter-svg-graph-icon" name="Graph" fill={iconColor} />
        }
      />
    </div>
  );
};

export default Sidebar;
